import type { ReactNode } from "react";
import styles from "./EmptyState.module.css";

/** Estado vacío consistente para listas sin datos (sin pacientes, sin
 *  evaluaciones…): ícono/emoji + título + descripción opcional + CTA opcional. */
export function EmptyState({
  icon,
  title,
  description,
  action,
}: {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <div className={styles.empty}>
      {icon ? (
        <div className={styles.icon} aria-hidden="true">
          {icon}
        </div>
      ) : null}
      <p className={styles.title}>{title}</p>
      {description ? <p className={styles.desc}>{description}</p> : null}
      {action ? <div className={styles.action}>{action}</div> : null}
    </div>
  );
}
